import React, { createContext, useContext } from 'react';
import { useInventory } from '../hooks/useInventory';
type InventoryValue = ReturnType<typeof useInventory>;
const InventoryContext = createContext<InventoryValue | null>(null);
export function InventoryProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const value = useInventory();
  return <InventoryContext.Provider value={value} data-id="element-411" data-mp="52n0x46jey0a">{children}</InventoryContext.Provider>;
}
export function useInventoryContext(): InventoryValue {
  const ctx = useContext(InventoryContext);
  if (!ctx) throw new Error('useInventoryContext debe usarse dentro de InventoryProvider');
  return ctx;
}